import LabelT from '@/Controls/Label';
import ControlBuilder from '@/Builder/ControlBuilder';
import LabelViewModelBuilder from '@/Builder/LabelViewModelBuilder';
import ComponentManager from '@/Management/ComponentManager';

export default class LabelBuilder<T = null> extends ControlBuilder<LabelT, T> {

    protected element: JQuery<HTMLElement>;
    private viewModelBuilder: LabelViewModelBuilder<this>;

    public constructor(parent?: T) {
        super(parent);
    }

    public withViewModel(): LabelViewModelBuilder<this> {
        if (this.viewModelBuilder == null)
            this.viewModelBuilder = new LabelViewModelBuilder<this>(this);

        return this.viewModelBuilder;
    }

    public withElement(element: JQuery<HTMLElement>): this {
        this.element = element;
        return this;
    }

    /**
     * @override
     * @inheritdoc 
     */
    protected buildInternal(): LabelT {
        const Label = ComponentManager.getControl<typeof LabelT>('Label');

        return new Label(this.viewModelBuilder.build(), this.element);
    }
}